
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/training/[:institutionName]/[:programName]",
      function () {
        return require("private-next-pages/training/[:institutionName]/[:programName]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/training/[:institutionName]/[:programName]"])
      });
    }
  